import React from "react";
import { Dropdown } from "semantic-ui-react";
import { withRouter } from "react-router-dom";

class MenuVentas extends React.Component {
  goToGeneral = () => this.props.history.push("/ventas/general/1");
  goToCorreo = () => this.props.history.push("/ventas/correo/1");
  goToTelefono = () => this.props.history.push("/ventas/telefono/1");
  goToVisita = () => this.props.history.push("/ventas/visita/1");
  goToExterno = () => this.props.history.push("/ventas/externo/1");
  goToTareas = () => this.props.history.push("/ventas/tareas/1");

  render() {
    return (
      <Dropdown item simple text="Ventas">
        <Dropdown.Menu>
          <Dropdown.Item content="General" onClick={this.goToGeneral} />
          <Dropdown.Item content="Correo" onClick={this.goToCorreo} />
          <Dropdown.Item content="Telefono" onClick={this.goToTelefono} />
          <Dropdown.Item content="Visita" onClick={this.goToVisita} />
          <Dropdown.Item content="Externo" onClick={this.goToExterno} />
          <Dropdown.Item content="Tareas" onClick={this.goToTareas} />
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default withRouter(MenuVentas);



// WEBPACK FOOTER //
// ./src/pages/appLayout/menuSuperior/MenuVentas.jsx